import React, {useState} from "react";
import DarkModeToggle from "react-dark-mode-toggle";
import "./Widgets.css";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterTweetEmbed,
} from "react-twitter-embed";
import SearchIcon from "@material-ui/icons/Search";

function Widgets() {
  const [isDarkMode, setIsDarkMode] = useState(() => false);

  return (
    <div className="widgets">
      <div className="widgets__input">
        <SearchIcon className="widgets__searchIcon" />
        <input placeholder="Search Twitter" type="text" />
      </div>

      <div className="widgets__widgetContainer">
        <h2>What's happening</h2>

        <TwitterTweetEmbed tweetId={"1295765557531365381"} />

        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="VAMPSO"
          options={{ height: 400 }}
        />

        <TwitterShareButton
          url={"https://facebook.com/iamDiwakarDJ"}
          options={{ text: "#reactjs is awesome", via: "djoshi" }}
        />
      </div>
    </div>
  );
}

export default Widgets;
